import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ListHeader } from 'containers';
import { useDispatch } from 'react-redux';
import { globalActions } from 'app/services/global';
import { Drawers } from 'app/types/drawer';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Paths, User } from 'constants/index';
import { useHasPermission } from 'hooks/authorization/useHasPermission';

const TableHeader = () => {
  const { t } = useTranslation();
  const canManageWorkers = useHasPermission(User.Permissions.MANAGE_WORKERS);

  const dispatch = useDispatch();
  const handleClick = () => dispatch(globalActions.openDrawer({ key: Drawers.ADD_WORKER }));

  const { pathname } = useLocation();
  const showActive = pathname.includes(Paths.WORKERS_ACTIVE);

  return (
    <ListHeader title={t('pages.workers.title')}>
      {showActive && canManageWorkers && (
        <Button onClick={handleClick} icon={<PlusOutlined />} type='primary'>
          {t('common.add', { type: t('entities.worker.title').toLowerCase() })}
        </Button>
      )}
    </ListHeader>
  );
};

export default TableHeader;
